import { rangeNumToTime } from "shared/lib/functions";

export const FILTERS_NAMES = [
  "baggage",
  "airports_from",
  "max_transfers",
  "airports_to",
  "airports_transfers",
  "transport_companies",
  "transport_companies_filter",
  "lowestPrice",
  "highestPrice",
  "onlySelected",
  "onlySelectedNoCombinations",
];

export const ONLY_SELECTED = "onlySelected";
export const ONLY_SELECTED_NO_COMBINATIONS = "onlySelectedNoCombinations";
export const MIN_TIME_FILTERS_DEFAULT_HOURS = 0;
export const MAX_TIME_FILTERS_DEFAULT_HOURS = 24;

export const initialWay = {
  departure: [MIN_TIME_FILTERS_DEFAULT_HOURS, MAX_TIME_FILTERS_DEFAULT_HOURS],
  arrival: [MIN_TIME_FILTERS_DEFAULT_HOURS, MAX_TIME_FILTERS_DEFAULT_HOURS],
  transfer: [MIN_TIME_FILTERS_DEFAULT_HOURS, MAX_TIME_FILTERS_DEFAULT_HOURS],
};

export const MAX_HOURS = 24;

export const defaultTimeRangeLabel = `${rangeNumToTime(0)} - ${rangeNumToTime(
  MAX_HOURS
)}`;

export const defaultRange = `${0}h - ${MAX_HOURS}h`;
